<template>
	<div class="scroller-container variable-container" id="scroller-variable">
		<div style="display: flex; height: 100%; width: 100%; flex-direction: column">
			<div style="display: flex; padding: 15px; width: 100%; height: 10%">
				<div style="flex: 1; display: flex; justify-content: flex-start">
					<p style="font-size: 1.75rem; padding: 10px">
						{{ $t(newVariablePopup ? "new-variable" : "variables") }}
					</p>
				</div>
				<div style="width: auto">
					<el-button icon="el-icon-error" @click="closeVariable" type="danger" plain></el-button>
				</div>
			</div>
			<div style="display: flex;  width: 100%; margin-top: 5px; margin-left: 5px; color: #ccc">
				<div style="width: 10%; height:auto;">
					<md-icon>help_outline</md-icon>
				</div>
				<div style=" width: 90%; height: 20px;">{{ $t("help-variables") }}</div>

			</div>
			<div style="height: 100%" v-if="!newVariablePopup">
				<div style="height: 80%; overflow-y: auto">
					<div style="display: flex; justify-content: space-around">
						<el-input
							ref="varsearch"
							:placeholder="$t('search-variable')"
							style="width: 40%"
							v-model="filterSearch"
						></el-input>
						<el-select style="width: 60%" v-model="filters" multiple filterable>
							<el-option
								v-for="item in variableTypes"
								:key="item.value"
								:label="$t(item.translationKey)"
								:value="item.value"
							></el-option>
						</el-select>
					</div>
					<div
						v-for="b in varSearched"
						:key="b.index + vars.length"
						class="vertical-scroller-item"
						style="cursor: pointer; border: 1pt solid #ccc"
						@click="ins($event, b)"
					>
						<div style="width: auto">
							<img :src="require('@/assets/icons/editor/variable.svg')" alt="dollar_alt" />
						</div>
						<div style="width: 45%">
							<p style="margin: 0 15px; font-weight: 500">{{ b.name | capitalize }}</p>
						</div>

						<div style="flex: 1; display: flex; justify-content: center">
							<el-tag v-if="b.level === -1">{{ $t("required-tag") }}</el-tag>
							<el-tag v-else-if="b.level === 0">{{ $t("global-tag") }}</el-tag>
							<el-tag v-else-if="b.level === 1">{{ $t("project-tag") }}</el-tag>
							<el-tag v-else-if="b.level === 2">{{ $t("procedure-tag") }}</el-tag>
							<el-tag v-else-if="b.level === 3">{{ $t("document-tag") }}</el-tag>
						</div>
					</div>
				</div>

				<div style="width: 100%; height: 20%">
					<div style="display: flex; justify-content: center">
						<el-button icon="el-icon-circle-plus" @click="add = true">{{ $t("new-variable") }}</el-button>
					</div>
				</div>
			</div>

			<variable-add :show="add" @add="handleAdd" @close="add = false"></variable-add>
		</div>
	</div>
</template>

<script>
import axios from "axios"
import { terminal_command } from "@/utils/terminal_command"
import { filters } from "@/utils/utils"
import VariableAdd from "@/modules/datas/variables/variables-components/variables-add.vue"

export default {
	name: "variable-popup",
	mixins: [terminal_command, filters],
	props: ["show", "editor", "commands"],
	components: { VariableAdd },
	data() {
		return {
			newVariablePopup: false,
			add: false,
			filters: [-1, 0, 1, 2, 3],
			filterSearch: "",
			variables: [],
			variableTypes: [
				{ value: -1, translationKey: "required-tag" },
				{ value: 0, translationKey: "global-tag" },
				{ value: 1, translationKey: "project-tag" },
				{ value: 2, translationKey: "procedure-tag" },
				{ value: 3, translationKey: "document-tag" }
			]
		}
	},
	created() {
		this.filters = [-1, 0, 1, 2, 3]
	},
	computed: {
		varSearched: function () {
			return this.variables.filter(
				str =>
					str.name
						.replace(/\s+/g, "")
						.toLowerCase()
						.includes(this.filterSearch.replace(/\s+/g, "").toLowerCase()) &&
					this.filters.includes(str.level)
			)
		}
	},
	watch: {
		show: function () {
			this.$nextTick(() => {
				this.$refs.varsearch.focus()
			})
			axios(`${process.env.VUE_APP_API_URL}/api/customfields/getByLevel`, {
				headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
			})
				.then(res => {
					this.variables = []
					this.vars = []
					for (let i = 0; i < res.data.length; i++) {
						let temp = res.data[i]
						for (const [_, value] of Object.entries(temp)) {
							this.variables.push({
								index: value.id,
								name: value.name,
								type: value.type,
								level: value.level,
								rules: value.rules
							})
						}
					}
				})
				.catch(err => {
					this.notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		},
		filters: function (el) {
			this.vars = this.variables.filter(x => el.includes(x.level))
		},
		filterSearch: function (el) {
			if (el === "$") {
				this.editor.chain().focus().insertContent("$").run()
				this.filterSearch = ""
				this.closeVariable()
			}
		}
	},
	methods: {
		handleAdd: function (variable) {
			this.add = false
			this.vars.push(variable)
		},
		closeVariable() {
			this.filterSearch = ""
			this.filters = [-1, 0, 1, 2, 3]
			this.$parent.varPopup = !this.$parent.varPopup
		},
		ins(e, el) {
			this.editor.chain().focus().setVariableSpan({ id: el.index, name: el.name }).run()
			this.closeVariable()
		}
	}
}
</script>
